import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom"; // ⭐ FIX 1: Link-Komponente importieren für weiche Navigation
import { useTranslation } from "react-i18next";
import "./SideBar.css";

import { setSidebar, getVersion } from "../../Redux/Actions/uiActions";
import { getSheets, getComposers, getComposerPage, getSheetPage, resetData } from "../../Redux/Actions/dataActions";
import { logoutUser } from "../../Redux/Actions/userActions";
import { connect } from "react-redux";
import { Typography } from "@material-ui/core";
import MdlSidebarOverlay from "./MdlSidebarOverlay";
import MdlSidebarSheetUpload from "./MdlSidebarSheetUpload";
import { displayFlagByCountryCode } from "../../Utils/utils"; 
import "./FalseVersion.css";

function SideBar({
  sidebar,
  version,
  userData,
  setSidebar,
  getVersion,
  resetData,
  logoutUser,
  getSheets,
  getComposers,
  props
}) {
  const [uploadModal, setUploadModal] = useState(false);
  const [falseVersion, setFalseVersion] = useState(false);
  const { t, i18n } = useTranslation();

  const onClickBtn = () => {
    setSidebar();
  };

  useEffect(() => {
    getVersion();
  }, [getVersion]);

  // ⭐ FIX 3: Ein zentraler Handler, der beim Navigieren im Hintergrund 
  // sofort die frischen Daten aus der SQLite-Datenbank nachlädt!
  const handleNavigationFetch = () => {
    console.log("[Sidebar] Navigiere... Rufe frische DB-Daten ab.");
    if (getSheets) getSheets();
    if (getComposers) getComposers();
  };

  return (
    <Fragment>
      {falseVersion && (
        <div className={sidebar ? "false-version" : "false-version false-active"}>
          <div>
            There is a new version of SheetAble available!{" "}
            <a href="https://github.com" target="_blank" rel="noreferrer">
              Pull it now
            </a>
          </div>
          <i className="bx bx-x" onClick={() => setFalseVersion(false)}></i>
        </div>
      )}

      <div className={sidebar ? "sidebar" : "sidebar active"}>
        <div className="logo_content">
          <div className="logo">
            <div className="logo_name">
              SheetAble <span>{version}</span>
            </div>
          </div>
          <i
            className={sidebar ? "bx bx-menu" : "bx bx-menu-alt-right"}
            id="btn"
            onClick={onClickBtn}
          ></i>
        </div>
        
        <ul className="nav_list">
          {/* ⭐ FIX 4: Alle <a> href-Navigationen auf <Link> to umgestellt */}
          <li>
            <Link to="/" onClick={handleNavigationFetch}>
              <i className="bx bx-grid-alt"></i>
              <span className="links_name">Home</span>
            </Link>
            <span className="tooltip">Home</span>
          </li>

          <li>
            <Link to="/sheets" onClick={handleNavigationFetch}>
              <i className="bx bx-bookmarks"></i>
              <span className="links_name">{t("common.sheets")}</span>
            </Link>
            <span className="tooltip">{t("common.sheets")}</span>
          </li>

          <li>
            <Link to="/composers" onClick={handleNavigationFetch}>
              <i className="bx bx-user"></i>
              <span className="links_name">{t("common.composers")}</span>
            </Link>
            <span className="tooltip">{t("common.composers")}</span>
          </li>

          <li>
            <Link to="/search">
              <i className="bx bx-search-alt-2"></i>
              <span className="links_name">{t("PageSideBar.search")}</span>
            </Link>
            <span className="tooltip">{t("PageSideBar.search")}</span>
          </li>
          
          <li>
            <a 
              href="#upload" 
              onClick={(e) => {
                e.preventDefault();
                setUploadModal(true);
              }}
            >
              <i className="bx bx-cloud-upload"></i>
              <span className="links_name">{t("PageSideBar.upload")}</span>
            </a>
            <span className="tooltip">{t("PageSideBar.upload")}</span>
          </li>
          
          <li>
            <a
              href="#sync"
              onClick={(e) => {
                e.preventDefault();
                resetData();
                window.location.reload();
              }}
            >
              <i className="bx bx-sync"></i>
              <span className="links_name">{t("PageSideBar.sync")}</span>
            </a>
            <span className="tooltip">{t("PageSideBar.sync")}</span>
          </li>

          <li>
            <Link to="/profile">
              <i className="bx bx-user-circle"></i>
              <span className="links_name">{t("PageSideBar.profile")}</span>
            </Link>
            <span className="tooltip">{t("PageSideBar.profile")}</span>
          </li>
		  
          {userData && userData.role === 0 && (
            <li>
              <Link to="/settings">
                <i className="bx bx-cog"></i>
                <span className="links_name">{t("PageSideBar.settings")}</span>
              </Link>
              <span className="tooltip">{t("PageSideBar.settings")}</span>
            </li>
          )}
        </ul>

        <div className="profile_content">
          <div className="profile">
            <div className="profile_details">
              <div className="name_job">
                 <Typography variant="caption" style={{ color: "#4f40b3" }}>{userData ? displayFlagByCountryCode(i18n.language.toUpperCase()): ""} </Typography>
                 <span>{userData ? userData.email : ""}</span>
              </div>
            </div>
            {/* Hier bleibt es beim <a>-Tag, da ein Login/Logout-Wechsel fast immer einen harten Reset erfordert */}
            <a href="/login">
              <i
                className="bx bx-log-out"
                id="log_out"
                onClick={() => {
                  logoutUser();
                }}
              ></i>
            </a>
          </div>
        </div>
      </div>

      <MdlSidebarOverlay title={t("PageSideBar.MdlSidebarOverlayTitle")} onClose={() => setUploadModal(false)} show={uploadModal} >
        <MdlSidebarSheetUpload onClose={() => setUploadModal(false)} />
      </MdlSidebarOverlay>

    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  sidebar: state.UI.sidebar,
  userData: state.user.userData,
  version: state.UI.version,
});

// ⭐ Inkludiert alle Actions ordnungsgemäß für die Verknüpfung
const mapActionsToProps = {
  setSidebar,
  getSheets,
  getComposers,
  logoutUser,
  getComposerPage,
  getSheetPage,
  resetData,
  getVersion,
};

export default connect(mapStateToProps, mapActionsToProps)(SideBar);
